import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/basic/button";
import Typography from "components/basic/typography";

interface ServicesStepProps {
  approved: boolean;
  onAddService: () => void;
}

/** The last step: publishing a service so customers can find the vendor. */
const ServicesStep: React.FC<ServicesStepProps> = ({
  approved,
  onAddService,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("onboarding");

  if (!approved) {
    return <Typography variant="body1">{t("services.locked")}</Typography>;
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="body1">{t("services.intro")}</Typography>
      <Button
        variant="contained"
        color="warning"
        style={{ color: theme.palette.common.white, alignSelf: "flex-start" }}
        onClick={onAddService}
      >
        {t("services.add")}
      </Button>
    </Box>
  );
};

export default ServicesStep;
